// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rrl-note {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: flex-start;
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 0.86rem;
  line-height: 1.5;
}

.rrl-note i {
  margin-top: 0.2rem;
  color: #ea580c;
}

.rrl-note__dest {
  font-weight: 600;
  color: #7c2d12;
}

.rrl-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.65rem;
  padding: 0.85rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border, #e2e8f0);
}

.rrl-filters__search {
  min-width: 220px;
  flex: 1 1 220px;
  max-width: 320px;
}

.rrl-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.rrr-tab-count {
  display: inline-flex;
  min-width: 1.25rem;
  margin-left: 0.35rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  background: rgba(15, 118, 110, 0.12);
  font-size: 0.7rem;
}

.rrl-chip--active .rrr-tab-count {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.rrr-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.rrr-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  border: 0;
  border-radius: 8px;
  background: #15803d;
  color: #fff;
  font: inherit;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}

.rrr-export-btn:hover:not(:disabled) {
  background: #166534;
}

.rrr-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.rrl-filters .rrl-chips {
  margin: 0;
}

.rrl-chip,
.rrl-tab {
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  cursor: pointer;
}

.rrl-chip--active,
.rrl-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.rrl-table td,
.rrl-table th {
  vertical-align: top;
}

.rrl-row {
  cursor: pointer;
}

.rrl-row:hover {
  background: #f0fdfa;
}

.rrl-row--nested td {
  background: #f8fafc;
}

.rrl-row--pending {
  opacity: 0.82;
}

.rrl-user {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.rrl-user span {
  color: #64748b;
  font-size: 0.78rem;
}

.rrl-copy {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.rrl-copy code,
.rrl-uuid {
  font-size: 0.78rem;
  background: #f1f5f9;
  padding: 0.12rem 0.35rem;
  border-radius: 4px;
}

.rrl-copy-btn,
.rrl-uuid {
  border: 0;
  background: transparent;
  color: #0f766e;
  cursor: pointer;
}

.rrl-uuid {
  font: inherit;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.rrl-amt--paid {
  color: #166534;
  font-weight: 700;
}

.rrl-amt--remain {
  color: #c2410c;
  font-weight: 700;
}

.rrl-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
  background: #f1f5f9;
  color: #475569;
}

.rrl-badge--vesting,
.rrl-badge--pending {
  background: #ffedd5;
  color: #c2410c;
}

.rrl-badge--complete,
.rrl-badge--paid {
  background: #dcfce7;
  color: #166534;
}

.rrl-badge--partial {
  background: #dbeafe;
  color: #1d4ed8;
}

.rrl-badge--empty {
  background: #f1f5f9;
  color: #64748b;
}

.rrl-badge--processing {
  background: #e0f2fe;
  color: #0369a1;
}

.rrl-pagination {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.85rem 1.5rem 1.1rem;
}

.rrl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: #64748b;
  text-align: center;
}

.rrl-empty--error {
  color: #b91c1c;
}

.rrl-toolbar {
  margin-bottom: 1rem;
}

.rrl-back {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  color: #0f766e;
  background: #fff;
  border: 1px solid rgba(15, 118, 110, 0.35);
  border-radius: 8px;
  text-decoration: none;
}

.rrl-user-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.15rem;
  margin-bottom: 1rem;
}

.rrl-user-head h2 {
  margin: 0 0 0.35rem;
}

.rrl-user-head p {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  color: #64748b;
}

.rrl-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.rrl-cards article {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}

.rrl-cards span,
.rrl-cards small {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 700;
}

.rrl-cards strong {
  display: block;
  margin-top: 0.3rem;
  color: #0f172a;
}

.rrl-cards__paid {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.rrl-cards__remain {
  background: #fff7ed;
  border-color: #fed7aa;
}

.rrl-tabs {
  display: flex;
  gap: 0.45rem;
  margin-bottom: 1rem;
}

.rrl-vest-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.rrl-vest {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
}

.rrl-vest header {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.rrl-vest header p {
  margin: 0.25rem 0 0;
  color: #64748b;
  font-size: 0.82rem;
}

.rrl-due-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.rrl-due-chips span {
  font-size: 0.7rem;
  font-weight: 700;
  background: #f1f5f9;
  color: #334155;
  border-radius: 999px;
  padding: 0.15rem 0.45rem;
}

.rrl-will {
  display: block;
  color: #c2410c;
  font-size: 0.7rem;
}

.rrl-leftover {
  margin-left: 0.2rem;
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 600;
}

.rrl-processing {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1rem;
  padding: 0.7rem 0.9rem;
  border-radius: 10px;
  background: #e0f2fe;
  border: 1px solid #7dd3fc;
  color: #075985;
  font-size: 0.86rem;
  font-weight: 600;
}

.rrl-round-block {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.rrl-round-block__head {
  padding: 0.9rem 1.1rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
}

.rrl-round-block__head h3 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 700;
  color: #0f172a;
}

.rrl-round-block__head p {
  margin: 0.2rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
}

.rrl-chips--history {
  margin-top: -0.25rem;
}

.rrl-by-earning {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.35rem 1rem 0.85rem;
  margin-bottom: 1rem;
}

.rrl-by-earning > summary {
  cursor: pointer;
  font-weight: 700;
  font-size: 0.9rem;
  color: #0f172a;
  padding: 0.7rem 0;
  list-style: none;
}

.rrl-by-earning > summary::-webkit-details-marker {
  display: none;
}

.rrl-by-earning > summary::before {
  content: "▸";
  display: inline-block;
  margin-right: 0.45rem;
  color: #0f766e;
}

.rrl-by-earning[open] > summary::before {
  content: "▾";
}

.rrl-by-earning > summary span {
  color: #64748b;
  font-weight: 600;
}

.rrl-vest__id {
  font-family: ui-monospace, monospace;
  font-size: 0.72rem;
  color: #94a3b8;
}

@media (max-width: 768px) {
  .rrl-user-head,
  .rrl-vest header {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/RoundReleaseLedgerPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":[".rrl-note {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  align-items: flex-start;\n  margin: 0 0 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  color: #9a3412;\n  font-size: 0.86rem;\n  line-height: 1.5;\n}\n\n.rrl-note i {\n  margin-top: 0.2rem;\n  color: #ea580c;\n}\n\n.rrl-note__dest {\n  font-weight: 600;\n  color: #7c2d12;\n}\n\n.rrl-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.65rem;\n  padding: 0.85rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n}\n\n.rrl-filters__search {\n  min-width: 220px;\n  flex: 1 1 220px;\n  max-width: 320px;\n}\n\n.rrl-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.rrr-tab-count {\n  display: inline-flex;\n  min-width: 1.25rem;\n  margin-left: 0.35rem;\n  padding: 0.05rem 0.35rem;\n  border-radius: 999px;\n  background: rgba(15, 118, 110, 0.12);\n  font-size: 0.7rem;\n}\n\n.rrl-chip--active .rrr-tab-count {\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n}\n\n.rrr-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rrr-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  border: 0;\n  border-radius: 8px;\n  background: #15803d;\n  color: #fff;\n  font: inherit;\n  font-size: 0.84rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.rrr-export-btn:hover:not(:disabled) {\n  background: #166534;\n}\n\n.rrr-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rrl-filters .rrl-chips {\n  margin: 0;\n}\n\n.rrl-chip,\n.rrl-tab {\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 0.4rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n\n.rrl-chip--active,\n.rrl-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.rrl-table td,\n.rrl-table th {\n  vertical-align: top;\n}\n\n.rrl-row {\n  cursor: pointer;\n}\n\n.rrl-row:hover {\n  background: #f0fdfa;\n}\n\n.rrl-row--nested td {\n  background: #f8fafc;\n}\n\n.rrl-row--pending {\n  opacity: 0.82;\n}\n\n.rrl-user {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.rrl-user span {\n  color: #64748b;\n  font-size: 0.78rem;\n}\n\n.rrl-copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.rrl-copy code,\n.rrl-uuid {\n  font-size: 0.78rem;\n  background: #f1f5f9;\n  padding: 0.12rem 0.35rem;\n  border-radius: 4px;\n}\n\n.rrl-copy-btn,\n.rrl-uuid {\n  border: 0;\n  background: transparent;\n  color: #0f766e;\n  cursor: pointer;\n}\n\n.rrl-uuid {\n  font: inherit;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.rrl-amt--paid {\n  color: #166534;\n  font-weight: 700;\n}\n\n.rrl-amt--remain {\n  color: #c2410c;\n  font-weight: 700;\n}\n\n.rrl-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.rrl-badge--vesting,\n.rrl-badge--pending {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.rrl-badge--complete,\n.rrl-badge--paid {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.rrl-badge--partial {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.rrl-badge--empty {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.rrl-badge--processing {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.rrl-pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.85rem 1.5rem 1.1rem;\n}\n\n.rrl-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  color: #64748b;\n  text-align: center;\n}\n\n.rrl-empty--error {\n  color: #b91c1c;\n}\n\n.rrl-toolbar {\n  margin-bottom: 1rem;\n}\n\n.rrl-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid rgba(15, 118, 110, 0.35);\n  border-radius: 8px;\n  text-decoration: none;\n}\n\n.rrl-user-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.15rem;\n  margin-bottom: 1rem;\n}\n\n.rrl-user-head h2 {\n  margin: 0 0 0.35rem;\n}\n\n.rrl-user-head p {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  color: #64748b;\n}\n\n.rrl-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.rrl-cards article {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n}\n\n.rrl-cards span,\n.rrl-cards small {\n  display: block;\n  font-size: 0.75rem;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.rrl-cards strong {\n  display: block;\n  margin-top: 0.3rem;\n  color: #0f172a;\n}\n\n.rrl-cards__paid {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.rrl-cards__remain {\n  background: #fff7ed;\n  border-color: #fed7aa;\n}\n\n.rrl-tabs {\n  display: flex;\n  gap: 0.45rem;\n  margin-bottom: 1rem;\n}\n\n.rrl-vest-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.rrl-vest {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n}\n\n.rrl-vest header {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.rrl-vest header p {\n  margin: 0.25rem 0 0;\n  color: #64748b;\n  font-size: 0.82rem;\n}\n\n.rrl-due-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.rrl-due-chips span {\n  font-size: 0.7rem;\n  font-weight: 700;\n  background: #f1f5f9;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.15rem 0.45rem;\n}\n\n.rrl-will {\n  display: block;\n  color: #c2410c;\n  font-size: 0.7rem;\n}\n\n.rrl-leftover {\n  margin-left: 0.2rem;\n  color: #64748b;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.rrl-processing {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1rem;\n  padding: 0.7rem 0.9rem;\n  border-radius: 10px;\n  background: #e0f2fe;\n  border: 1px solid #7dd3fc;\n  color: #075985;\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.rrl-round-block {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.rrl-round-block__head {\n  padding: 0.9rem 1.1rem 0.75rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.rrl-round-block__head h3 {\n  margin: 0;\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.rrl-round-block__head p {\n  margin: 0.2rem 0 0;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.rrl-chips--history {\n  margin-top: -0.25rem;\n}\n\n.rrl-by-earning {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.35rem 1rem 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.rrl-by-earning > summary {\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: #0f172a;\n  padding: 0.7rem 0;\n  list-style: none;\n}\n\n.rrl-by-earning > summary::-webkit-details-marker {\n  display: none;\n}\n\n.rrl-by-earning > summary::before {\n  content: \"▸\";\n  display: inline-block;\n  margin-right: 0.45rem;\n  color: #0f766e;\n}\n\n.rrl-by-earning[open] > summary::before {\n  content: \"▾\";\n}\n\n.rrl-by-earning > summary span {\n  color: #64748b;\n  font-weight: 600;\n}\n\n.rrl-vest__id {\n  font-family: ui-monospace, monospace;\n  font-size: 0.72rem;\n  color: #94a3b8;\n}\n\n@media (max-width: 768px) {\n  .rrl-user-head,\n  .rrl-vest header {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
